/* Rate cards + version history (verbatim from mockup core.js).
   DUMMY_RATECARDS holds the CURRENT sample rows; history + archived rows below. */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_RATECARDS = SUPPLY_DATA.rateCards
export const RATECARD_HISTORY = SUPPLY_DATA.rateHistory
export const RATECARD_HISTORICAL_ROWS = SUPPLY_DATA.rateHistoricalRows
